module.exports = __webpack_public_path__ + "media/logos/press-logo-spread-persona-7bf4940e.png";